exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folderSelected{background-color:#ecebe9;color:#454545}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-nav/hierarchySidenav.less
// module id = ./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/hierarchy-nav/hierarchySidenav.less
// module chunks = 8